import { render, staticRenderFns } from "./WizardContentFixedTextIndicator.vue?vue&type=template&id=1fad896e&scoped=true&"
import script from "./WizardContentFixedTextIndicator.vue?vue&type=script&lang=ts&"
export * from "./WizardContentFixedTextIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentFixedTextIndicator.vue?vue&type=style&index=0&id=1fad896e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fad896e",
  null
  
)

export default component.exports